export const HERO_HEADLINE = "Your portfolio, built by AI.";

export const HERO_HEADLINE_FLAG_KEY = "hero_headline_v2";

export const HERO_HEADLINE_SAVINGS =
  "Cash sitting in savings? See the portfolio AI would build for it.";

export type HeroHeadlineVariant = "control" | "savings";

export function normalizeHeroHeadlineVariant(
  raw: string | boolean | undefined,
): HeroHeadlineVariant {
  if (raw === "savings") return "savings";
  return "control";
}

/** The one question the hero asks; each answer opens /quiz at that drop level. */
export const HERO_QUESTION = "How big a drop can you live with?";

/** Trust line under the hero form. */
export const HERO_TRUST_LINE = "You keep your broker. Not investment advice.";

/**
 * Optional compliance guard subline. Off by default; enabling requires
 * a frontend redeploy (this is a compile-time constant, not a remote flag).
 */
export const HERO_GUARD_LINE_ENABLED = false;

export const HERO_GUARD_LINE_COPY =
  "No guarantees. We never touch your money. See every pick, including losses.";
